// 오른쪽 위 아이콘 메뉴 줄(2026-10-27 대표님 "일일·아이템·가방·인벤토리 같은 걸 누르면 바로 원샷으로 들어가는 아이콘 버튼").
// 승인 콘셉트(concept/ui/ui-village-hud.webp)처럼 어두운 남색 판 + 금테 위에 GPT 메뉴 그림(public/assets/ui/icons/menu-*.webp)을 얹고,
// 작은 이름표와 빨간 알림 점(안 쓴 스킬 포인트·받을 일일 보상)을 단다. 골드 알약은 줄 왼쪽.
// 누르면 window 이벤트 MENU_EVENT(detail = MenuId)를 보내고 ui/index.ts가 기존 창 열기 경로(단축키와 같은 명령)로 연다. 영웅 고르기 창만 여기서 직접 연다.
// 자리는 hudMenuLayout(순수 함수)이 정하고 hud.ts가 화면 크기가 바뀔 때 place()로 넘긴다. 매 프레임 update는 값이 바뀔 때만 DOM을 쓴다.
import type { GameCommand, GameView } from '../shared/types';
import { Scene } from '../shared/types';
import { assetUrl } from '../pwa/assetMap';
import { FONT, FONT_NUM, el } from './dom';
import { HeroPicker } from './heroPicker';
import { MENU_META, foldedMenu, menuKeyOf, villageMenu, type HudMenuLayout, type MenuId } from './hudMenuLayout';
import { goldText } from './rpgModel';
import { keymap } from '../shared/keymap';
import { growthOf, hasUnspentPoints } from './skillTreeModel';

export const MENU_EVENT = 'dh-menu';
/** 다른 UI가 알려 주는 알림 점(일일 패널이 받을 보상이 있을 때 켠다) */
export const menuBadges = { daily: false, dailyOpen: false, mail: false };
/** 「파티」「우편함」 단추(레인 D): 누르면 이 이벤트(detail = 'party' | 'mail' | 'market')를 보낸다. partyPanel·mailPanel이 받아 창을 토글한다 */
export const PARTY_MENU_EVENT = 'dh-party-menu';
const PARTY_SVG: Record<string, string> = {
  party: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 11a3.2 3.2 0 1 0 0-6.4A3.2 3.2 0 0 0 9 11zm7 .5a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2zM9 12.6c-2.9 0-5.4 1.5-5.4 3.7V19h10.8v-2.7c0-2.2-2.5-3.7-5.4-3.7zm7 .6c-.5 0-1 .1-1.5.2 1.1.9 1.8 2.1 1.8 3.5V19H21v-2.2c0-1.9-2.2-3.6-5-3.6z"/></svg>',
  market: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M4 9.5 5.6 5h12.8L20 9.5V11a2.3 2.3 0 0 1-4 1.5 2.3 2.3 0 0 1-4 0 2.3 2.3 0 0 1-4 0A2.3 2.3 0 0 1 4 11zM5.5 13.6c.9.2 1.8 0 2.5-.5.9.8 2.1 1 3 .6.4-.2.7-.4 1-.6 1 .8 2.4 1 3.5.4.2-.1.4-.2.5-.4.7.5 1.5.7 2.5.5V19H5.5z"/></svg>',
  mail: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 6.5A1.5 1.5 0 0 1 4.5 5h15A1.5 1.5 0 0 1 21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5zm2.2.6 6.8 5.2 6.8-5.2zM19 8.9l-7 5.3-7-5.3v8.6h14z"/></svg>',
};
/** 「더보기」 펼침 상태 저장(기기별 편의 — 실패해도 접힌 상태로 돈다) */
const MORE_KEY = 'dungeonhero.ui.menuMore';
function loadMore(): boolean { try { return localStorage.getItem(MORE_KEY) === '1'; } catch { return false; } }
function saveMore(on: boolean): void { try { localStorage.setItem(MORE_KEY, on ? '1' : '0'); } catch { /* 저장 못 해도 이번 실행 동안은 유지 */ } }
const MORE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M4 6h16v2.6H4zm0 5h16v2.6H4zm0 5h16v2.6H4z"/></svg>';

const STYLE_ID = 'dh-menu-style';
const CSS =
  '.dh-mb{position:absolute;box-sizing:border-box;padding:0;border-radius:12px;cursor:pointer;pointer-events:auto;touch-action:manipulation;' +
  'border:2px solid #c8963e;background:radial-gradient(90% 80% at 50% 30%,#2b3a68 0%,#141c38 70%,#0b1024 100%);' +
  'box-shadow:inset 0 0 0 1px rgba(255,215,106,.25),0 0 0 2px rgba(9,12,26,.85),0 3px 8px rgba(0,0,0,.55);-webkit-tap-highlight-color:transparent;transition:filter 60ms ease-out}' +
  '.dh-mb:hover{filter:brightness(1.15)}.dh-mb:active{filter:brightness(1.3);transform:translateY(1px)}' +
  '.dh-mb:focus-visible{outline:3px solid #fff;outline-offset:2px}' +
  // 작은 단추(폰 34px)도 누름 영역은 가로·세로 44px 이상(그림 크기는 그대로). 단추 사이 간격은 hudMenuLayout이 44px 걸음으로 벌려 이웃과 겹치지 않는다
  '.dh-mb::before{content:"";position:absolute;left:50%;top:50%;width:max(100%,44px);height:max(100%,44px);transform:translate(-50%,-50%)}' +
  '.dh-mb.sv{display:grid;place-items:center;color:#ffd76a}.dh-mb.sv svg{width:58%;height:58%}' +
  '.dh-mb.more{display:grid;place-items:center;color:#ffd76a}.dh-mb.more svg{width:58%;height:58%;transition:transform .15s ease-out}.dh-mb.more[aria-expanded="true"] svg{transform:rotate(90deg)}' +
  '.dh-mb.more[aria-expanded="true"]{background:radial-gradient(90% 80% at 50% 30%,#4a3a18 0%,#241a08 75%);border-color:#ffd76a}' +
  '.dh-mb img{position:absolute;left:8%;top:4%;width:84%;height:84%;object-fit:contain;pointer-events:none;filter:drop-shadow(0 2px 2px rgba(0,0,0,.7))}' +
  '.dh-mb.lab img{left:14%;top:2%;width:72%;height:72%}' +
  '.dh-mb .t{position:absolute;left:0;right:0;bottom:1px;display:none;text-align:center;font:800 10.5px ' + FONT + ';color:#fff2c2;letter-spacing:.2px;white-space:nowrap;' +
  'text-shadow:0 1px 0 #000,0 0 3px #000,0 0 6px rgba(0,0,0,.9);pointer-events:none}' +
  '.dh-mb.lab .t{display:block}' +
  '.dh-mb .d{position:absolute;right:-4px;top:-4px;width:11px;height:11px;border-radius:50%;background:radial-gradient(circle at 35% 30%,#ff9aa0,#e8243a 60%,#8a0f1c);' +
  'box-shadow:0 0 0 2px rgba(9,12,26,.95),0 0 8px rgba(255,42,61,.9);pointer-events:none;display:none}' +
  '.dh-mb .d.on{display:block}' +
  '.dh-mgold{position:absolute;box-sizing:border-box;display:flex;align-items:center;gap:6px;padding:0 12px 0 4px;border-radius:999px;border:2px solid #c8963e;' +
  'background:linear-gradient(180deg,rgba(26,34,62,.95),rgba(12,17,34,.95));font:900 16px ' + FONT_NUM + ';color:#ffd76a;white-space:nowrap;overflow:hidden;' +
  'box-shadow:0 0 0 2px rgba(9,12,26,.8),0 3px 8px rgba(0,0,0,.45);pointer-events:auto}' +
  '.dh-mgold img{flex:0 0 auto;height:78%;aspect-ratio:1;object-fit:contain}' +
  '.dh-mgold span{flex:1;min-width:0;text-align:right;text-overflow:ellipsis;overflow:hidden;letter-spacing:-.3px}' +
  // 창(가방·NPC·지도·퀘스트·일일·일시정지)이 열리면 오른쪽 가장자리 커뮤니티 말풍선이 창을 가리지 않게 숨긴다(ui/index.ts가 body 클래스를 켠다)
  'body.dh-win-open [data-testid="community-open"]{display:none!important}' +
  '.dh-mhero{position:absolute;width:0;height:0;pointer-events:none}' +
  '.dh-mhero .dh-hp-panel{left:auto;right:-48px;pointer-events:auto}';

interface MenuBtn { id: MenuId; b: HTMLButtonElement; dot: HTMLSpanElement; shown: boolean; dotOn: boolean }

export function menuIconUrl(icon: string): string { return assetUrl('ui/icons/menu-' + icon + '.webp'); }

export class MenuBar {
  private readonly btns: MenuBtn[] = [];
  private readonly gold: HTMLDivElement;
  private readonly goldVal: HTMLSpanElement;
  private readonly heroHost: HTMLDivElement;
  private readonly picker: HeroPicker;
  private kGold = '';
  private kScene = '';
  private kLabels = -1;
  private kHero = false;
  /** 「더보기」 펼침(접힌 세트·지도·상점·영웅을 꺼낸다). 바뀌면 hud.ts가 다시 배치한다 */
  expanded = loadMore();

  constructor(parent: HTMLElement, private readonly view: GameView, send: (c: GameCommand) => void, touch: boolean) {
    if (!document.getElementById(STYLE_ID)) {
      const st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    this.gold = el('div', 'display:none;', parent);
    this.gold.className = 'dh-mgold';
    this.gold.dataset.testid = 'hud-gold';
    const coin = el('img', '', this.gold);
    coin.src = assetUrl('ui/items/cur_gold.webp'); coin.alt = ''; coin.draggable = false;
    coin.onerror = () => { coin.style.visibility = 'hidden'; };
    this.goldVal = el('span', '', this.gold, '');
    this.heroHost = el('div', '', parent);
    this.heroHost.className = 'dh-mhero';
    this.picker = new HeroPicker(this.heroHost, view, send, { external: true });
    for (const id of villageMenu()) {
      const m = MENU_META[id];
      const b = el('button', 'display:none;', parent);
      b.type = 'button';
      b.className = 'dh-mb';
      b.dataset.testid = 'menu-' + id;
      b.dataset.sfx = 'event';
      const tip = (): void => {
        const k = menuKeyOf(id, keymap.preset);
        const t = m.label + (k && !touch ? ' (' + k + ')' : '');
        b.setAttribute('aria-label', t);
        b.setAttribute('data-tip', t);
      };
      tip();
      if (id === 'skill' || id === 'stat') keymap.subscribe(tip); // 키 배치를 바꾸면 툴팁도 따라간다
      if (id === 'more') {
        b.classList.add('more');
        b.insertAdjacentHTML('afterbegin', MORE_SVG);
        b.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
      } else if (id === 'party' || id === 'mail' || id === 'market') {
        b.classList.add('sv');
        b.insertAdjacentHTML('afterbegin', PARTY_SVG[id]);
      } else {
        const im = el('img', '', b);
        im.src = menuIconUrl(m.icon); im.alt = ''; im.draggable = false;
        // 그림을 못 받으면 글자로(빈 판이 남지 않게)
        im.onerror = () => { im.remove(); b.classList.add('lab'); };
      }
      el('span', '', b, m.label).className = 't';
      const dot = el('span', '', b);
      dot.className = 'd';
      dot.dataset.testid = 'menu-dot-' + id;
      // 마우스로 눌러도 포커스를 가져가지 않는다(포커스가 남으면 Space·Enter가 단추 클릭이 되어 각성·대화와 겹친다)
      b.addEventListener('pointerdown', (e) => e.preventDefault());
      b.addEventListener('click', () => {
        if (id === 'hero') { this.picker.toggle(); return; }
        if (id === 'more') { this.expanded = !this.expanded; saveMore(this.expanded); b.setAttribute('aria-expanded', this.expanded ? 'true' : 'false'); if (!this.expanded) this.picker.close(); return; }
        this.picker.close();
        if (id === 'party' || id === 'mail' || id === 'market') { window.dispatchEvent(new CustomEvent<string>(PARTY_MENU_EVENT, { detail: id })); return; }
        window.dispatchEvent(new CustomEvent<MenuId>(MENU_EVENT, { detail: id }));
      });
      this.btns.push({ id, b, dot, shown: false, dotOn: false });
    }
  }

  /** 화면 크기·장면이 바뀌어 배치가 새로 나왔을 때(ox, oy = 묶음 왼쪽 위, 자식은 그 기준 좌표) */
  place(p: HudMenuLayout, ox: number, oy: number): void {
    const put = (e: HTMLElement, r: { x: number; y: number; w: number; h: number }): void => {
      e.style.left = (r.x - ox) + 'px'; e.style.top = (r.y - oy) + 'px'; e.style.width = r.w + 'px'; e.style.height = r.h + 'px';
    };
    for (const m of this.btns) {
      const i = p.items.indexOf(m.id);
      m.shown = i >= 0;
      m.b.style.display = m.shown ? 'block' : 'none';
      if (m.shown) put(m.b, p.buttons[i]);
      if (m.id === 'hero' && m.shown) {
        const r = p.buttons[i];
        this.heroHost.style.left = (r.x - ox) + 'px'; this.heroHost.style.top = (r.y + r.h - oy) + 'px';
      }
    }
    if (p.gold) put(this.gold, p.gold);
    this.gold.style.display = p.gold ? 'flex' : 'none';
    this.gold.style.fontSize = Math.round(Math.max(13, Math.min(18, p.gold ? p.gold.h * 0.4 : 16))) + 'px';
    const lab = p.labels ? 1 : 0;
    if (lab !== this.kLabels) {
      this.kLabels = lab;
      for (const m of this.btns) if (m.id !== 'more') m.b.classList.toggle('lab', lab === 1 || !m.b.querySelector('img'));
    }
  }

  /** 매 프레임: 골드·알림 점·영웅 창(값이 바뀔 때만 DOM을 쓴다) */
  update(on: boolean): void {
    const v = this.view;
    const village = on && v.flow.scene === Scene.Village;
    const sc = village ? 'v' : on ? 'd' : '';
    if (sc !== this.kScene) this.kScene = sc;
    const heroOn = village && !v.flow.paused && v.village.menuNpc < 0 && !v.village.inventoryOpen;
    if (heroOn !== this.kHero || heroOn) { this.kHero = heroOn; this.picker.update(heroOn); }
    if (village) {
      const gt = goldText(v.profile);
      if (gt !== this.kGold) { this.kGold = gt; this.goldVal.textContent = gt; this.gold.setAttribute('aria-label', '보유 골드 ' + gt); }
    }
    const g = growthOf(v);
    const skillDot = village && hasUnspentPoints(g) && g!.mode === 'ok';
    // 일일 게시판은 설정(톱니) 창 바로가기로 옮겼으므로 받을 보상 점은 톱니에. 접힌 단추에 점이 생기면 「더보기」에 점
    const dotOf = (id: MenuId): boolean => id === 'skill' ? skillDot : id === 'settings' ? village && menuBadges.daily : id === 'mail' ? village && menuBadges.mail : false;
    let foldedDot = false;
    if (!this.expanded) for (const id of foldedMenu()) if (dotOf(id)) foldedDot = true;
    for (const m of this.btns) {
      if (!m.shown) continue;
      const d = m.id === 'more' ? foldedDot : dotOf(m.id);
      if (d !== m.dotOn) { m.dotOn = d; m.dot.classList.toggle('on', d); m.dot.setAttribute('aria-label', d ? '새 알림' : ''); }
    }
  }

  /** 시험·QA: 단추 요소 */
  button(id: MenuId): HTMLButtonElement | null { return this.btns.find((m) => m.id === id)?.b ?? null; }
}
